/**
 * @description global page routes
 */
export const PAGE_HOME = "/home";
export const PAGE_LOGIN = "/login";
export const PAGE_DASHBOARD = "/dashboard";